import React, { createContext, useContext, useEffect, useState } from "react";
import { translations, LANGUAGES } from "./translations";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    if (typeof window === "undefined") return "es";
    const stored = window.localStorage.getItem("grc_lang");
    if (stored && translations[stored]) return stored;
    const browser = (navigator.language || "es").slice(0, 2);
    return translations[browser] ? browser : "es";
  });

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.localStorage.setItem("grc_lang", lang);
      document.documentElement.lang = lang;
    }
  }, [lang]);

  const setLang = (code) => {
    if (translations[code]) setLangState(code);
  };

  const t = translations[lang] || translations.es;

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, languages: LANGUAGES }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLanguage must be used within LanguageProvider");
  return ctx;
};
